<template>
  <div
    class="side-nav"
    :class="{ 'side-nav-open': open }"
  >
    <div class="side-nav-close" @click="$emit('close')"></div>
    <div class="side-nav-content">
      <div class="side-nav-heritage">
        <h6>My Heritage ID</h6>
        <span class="side-nav-heritage-id"> {{ $store.state.auth.heritageId }} </span>
      </div>
      <div class="d-flex flex-column">
        <router-link  
          class="side-nav-link py-3" 
          :to="getPath(`/profile`)"
        >
          My Profile
        </router-link>
        <router-link 
          class="side-nav-link py-3" 
          :to="getPath(`/my-heritage`)"
        >
          My Past Activities
        </router-link>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import Vue from 'vue'
import Options from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { getPath } from '@/utils/general-utils'


@Options({
  props: {
    open: Boolean,
  }
})
export default class SideBarMenu extends Vue {
  getPath = getPath
  open!: boolean

  @Watch('open')
  onOpenChange(open: boolean): void {
    if (open) {
      document.body.style.overflowY = 'hidden'
    } else {
      document.body.style.overflowY = 'visible'
    }
  }

  mounted(): void {
     document.body.style.overflowY = 'visible'
  }
}
</script>

<style lang="scss">
.side-nav{
  position: fixed;
  height: 100vh;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 210;
  display: flex;
  visibility: hidden;
  opacity: 0;
  justify-content: flex-end;
  transition: opacity 0.3s ease;
}

.side-nav-open {
  visibility: visible;
  opacity: 1;
}

.side-nav-close {
  height: 100vh;
  width: 10vw;
}

.side-nav-content {
  height: 100vh;
  width: 90vw;
  background: white;
  padding: 25px 26px;
  
}

.side-nav-link {
  color: black !important;
  font-size: 20px;
  font-weight: 700;

}

.side-nav-heritage {
  line-height: 15px;
  font-size: 17px;

  &-id {
    color: #333;
  }
}


</style>